// utils/cloudinary.js

export function cloudinaryImage(url) {
  // אם זו לא תמונה מ־Cloudinary — מחזירים כמו שהיא
  if (!url.includes("res.cloudinary.com")) return url;

  return url
    // modern formats + better perceived quality + sharpness on high-DPR displays
    .replace("/image/upload/", "/image/upload/f_auto,q_auto:good,dpr_auto/")
    // remove HEIC extension if present (avoid forcing unsupported formats)
    .replace(/\.(heic|HEIC)$/g, "");
}
